/**
 * 根據會員等級的代碼取得會員等級的名稱
 * @param code: EnumMemberTypeCode, default?: string
 * @returns EnumMemberType
 */

const provideMemberTypeName = (
  code: EnumMemberTypeCode,
  defaultName?: string
): string => {
  const result = defaultName || '';

  switch (code) {
    case EnumMemberTypeCode.VIP:
      return EnumMemberType.VIP;
    case EnumMemberTypeCode.GOLD:
      return EnumMemberType.GOLD;
    case EnumMemberTypeCode.SILVER:
      return EnumMemberType.SILVER;
    case EnumMemberTypeCode.REGULAR:
      return EnumMemberType.REGULAR;
    default:
      return result;
  }
};

export default provideMemberTypeName;
